const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const getAffiliatorAccountApi = async () => {
  const token = localStorage.getItem("token");

  if (!token) {
    console.error('[getAffiliatorAccountApi] Ошибка: Токен авторизации не найден.');
    // throw new Error("Токен авторизации не найден."); 
  }

  try {
    const response = await fetch(`${API_BASE_URL}/affiliator/user/my-account`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('[getAffiliatorAccountApi] Ошибка получения данных аккаунта аффилиата:', errorData);
      throw { ...errorData, statusCode: response.status };
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('[getAffiliatorAccountApi] Ошибка сети или другая ошибка при получении данных аккаунта аффилиата:', error);
    throw error;
  }
};